import { reactive } from 'vue';
import userService from '@/services/userService';
import { getUserFromToken } from '@/utils/tokenUtils';

// Глобальное состояние токенов
const tokenState = reactive({
  remaining_requests: 0,
  daily_limit: 0,
  subscription_plan: 'basic',
  subscription_end_date: null,
  loading: false
});

// Ссылки на компоненты TokenCounter для уведомления об обновлениях
const tokenCounterRefs = new Set();

export function useTokenManager() {
  // Обновление данных о токенах
  const updateTokenData = async () => {
    try {
      tokenState.loading = true;
      const data = await userService.getUserTokens();
      
      tokenState.remaining_requests = data.remaining_requests;
      tokenState.daily_limit = data.daily_limit;
      tokenState.subscription_plan = data.subscription_plan;
      tokenState.subscription_end_date = data.subscription_end_date;
      
      // Уведомляем все компоненты TokenCounter об обновлении
      tokenCounterRefs.forEach(ref => {
        if (ref && ref.updateFromWebSocket) {
          ref.updateFromWebSocket(data);
        }
      });
    } catch (error) {
      console.error('Ошибка при обновлении данных о токенах:', error);
    } finally {
      tokenState.loading = false;
    }
  };

  // Уменьшение счетчика токенов (вызывается после выполнения запроса)
  const decrementTokens = (count = 1) => {
    tokenState.remaining_requests = Math.max(0, tokenState.remaining_requests - count);
    
    // Уведомляем все компоненты TokenCounter об обновлении
    tokenCounterRefs.forEach(ref => {
      if (ref && ref.updateFromWebSocket) {
        ref.updateFromWebSocket({
          remaining_requests: tokenState.remaining_requests,
          daily_limit: tokenState.daily_limit,
          subscription_plan: tokenState.subscription_plan,
          subscription_end_date: tokenState.subscription_end_date
        });
      }
    });
  };

  // Регистрация компонента TokenCounter
  const registerTokenCounter = (ref) => {
    if (ref) {
      tokenCounterRefs.add(ref);
    }
  };

  // Отмена регистрации компонента TokenCounter
  const unregisterTokenCounter = (ref) => {
    if (ref) {
      tokenCounterRefs.delete(ref);
    }
  };

  // Инициализация данных о токенах
  const initTokenData = async () => {
    const tokenData = getUserFromToken();
    if (tokenData) {
      await updateTokenData();
    }
  };

  return {
    tokenState,
    updateTokenData,
    decrementTokens,
    registerTokenCounter,
    unregisterTokenCounter,
    initTokenData
  };
}
